import { phpJsonString } from './php-json-values';

const fields = ['item_name','item_type','flavor_text','item_created_by_id','item_description','homebrew'] as const;
export type InventoryTemplateIdentity = Record<typeof fields[number],string>;
export type InventoryTemplateQuery = (id: string,reason: 'ft_inventory_template_identity',suppressMissingWarning: true) => unknown;
const arrayLike = (value: unknown): value is Readonly<Record<string,unknown>> | readonly unknown[] => value !== null && typeof value === 'object';
const own = (row: unknown,key: string): unknown => arrayLike(row) && Object.prototype.propertyIsEnumerable.call(row,key)
    ? (row as Readonly<Record<string,unknown>>)[key] : undefined;

/** Full ft_inventory_template_identity: definition-only request memo, including
 * known misses. Errors do not seed a miss. No UUID gate or instance-result memo.
 * The query supplies an actual definition result; this resolver never fetches.
 */
export function createInventoryTemplateIdentityResolver(queryFullItem: InventoryTemplateQuery): (id: string) => InventoryTemplateIdentity | null {
    const memo = new Map<string,InventoryTemplateIdentity | null>();
    return rawId => {
        if (rawId == null || arrayLike(rawId)) throw new TypeError('Template identity requires a scalar string');
        const id = phpJsonString(rawId);
        if (memo.has(id)) { const value = memo.get(id)!; return value === null ? null : {...value}; }
        const full = queryFullItem(id,'ft_inventory_template_identity',true), items = own(full,'items');
        if (!arrayLike(full) || !arrayLike(items)) { memo.set(id,null); return null; }
        const identity = Object.fromEntries(fields.map(key => {
            const raw = own(items,key);
            return [key,phpJsonString(arrayLike(raw) ? own(raw,'0') ?? '' : raw ?? '')];
        })) as InventoryTemplateIdentity;
        memo.set(id,identity); return {...identity};
    };
}
